import React from 'react';
import ProjectSession from "../../model2/project/project-session"
import {ProjectSystemTypeIcon} from "../../model2/project/types"
import {ProjectIconDictionary} from "../../gd/const/project"

type Props = {
    project?    : ProjectSession
    projectId?  : ID
    color?      : number | 'disabled'
    colorize?   : boolean
    isExpanded? : boolean     // if true replace folder iwth open-folder
    className?  : string
}

export default class ProjectTypeIcon extends React.Component<Props> {

    getColorClass = () => {
        const project = (this.props.projectId)?gd.session.projects.get(this.props.projectId):this.props.project
        return 'gd-c-font-'+project!.color
    }

    render() {
        const project = this.props.projectId ? gd.session.projects.get(this.props.projectId) : this.props.project

        if (!project) {
            console.error("no project found in icon")
            return false
        }

        const systemType = project.systemType

        let colorClass
        if (this.props.colorize) {
            colorClass = this.getColorClass()
        }

        if (this.props.color && this.props.color === 'disabled') colorClass = 'color-disabled';

        let iconClass = (project.projectIcon) ?
            ProjectIconDictionary[project.projectIcon as keyof object]
            :
            // @ts-ignore
            ProjectIconDictionary[ProjectSystemTypeIcon[systemType]]

        // open folder patch
        if (this.props.isExpanded && iconClass === 'ii5-folder') {
            iconClass = 'ii5-folder-open';
        }

        const classes = Classes("gd-project-type-icon", iconClass,  colorClass, this.props.className);

        return <div className={classes}/>
    }
}